import createTheme from '@mui/material/styles/createTheme';
import custom_palettes from './custom_palettes';
import custom_typographys from './custom_typographys';
import custom_buttons from './custom_buttons';
import custom_breakpoints from './custom_breakpoints';

declare module '@mui/material/styles' {
  interface Theme {}
  // allow configuration using `createTheme`
  interface ThemeOptions {}
}

// =============================================================================
const theme = createTheme({
  palette: custom_palettes,
  typography: custom_typographys,
  breakpoints: custom_breakpoints,
  components: {
    MuiButton: custom_buttons as any
  }
});

export default theme;
